// @ts-check
/**
 * Defines the query keys for creating envelopes.
 */
export const envelopeKeys = {
  /**
   * Represents all envelope query keys.
   *
   * @type {['envelopes']}
   */
  all: ['envelopes'],

  /**
   * Generates the envelope query keys for retrieving envelope details.
   *
   * @param {string} fingerprint - The fingerprint of the envelope.
   *
   * @returns {['envelopes', string]}
   */
  details: fingerprint => [...envelopeKeys.all, fingerprint],

  /**
   * Generates the envelope query keys for retrieving envelope documents.
   * @param {string} fingerprint - The fingerprint of the envelope.
   *
   * @returns {['envelopes', string, 'documents']}
   */
  documents: fingerprint => [
    ...envelopeKeys.details(fingerprint),
    'documents',
  ],

  /**
   * Generates the envelope query keys for retrieving envelope parties.
   * @param {string} fingerprint - The fingerprint of the envelope.
   *
   * @returns {['envelopes', string, 'parties']}
   */
  parties: fingerprint => [
    ...envelopeKeys.details(fingerprint),
    'parties',
  ],

  /**
   * Generates the envelope query keys for retrieving envelope fields.
   * @param {string} fingerprint - The fingerprint of the envelope.
   *
   * @returns {['envelopes', string, 'fields']}
   */
  fields: fingerprint => [
    ...envelopeKeys.details(fingerprint),
    'fields',
  ],

  /**
   * Generates the envelope query keys for retrieving envelope sharing information.
   *
   * @param {string} fingerprint - The fingerprint of the envelope.
   *
   * @returns {['envelopes', string, 'sharing']}
   */
  sharing: fingerprint => [
    ...envelopeKeys.details(fingerprint),
    'sharing'],
};

/** @typedef {typeof envelopeKeys} TEnvelopeKeys */
